import { Activity } from "../entities/interfaces/actviity";
import {
  PeriodicMetric,
  StaffWithPerformance,
} from "../entities/interfaces/analytics";
import {
  ComprehensiveReportFilters,
  ComprehensiveReportResponse,
  FiltersData,
  InvoiceByServiceReport,
} from "../entities/interfaces/report";
import { EodReport } from "../entities/interfaces/reports";
import Api, { ApiResponse } from "../utils/axios";

export const eodReport = async (from: string, to: string): Promise<any> => {
  return await Api.get(`/reports/eod?${new URLSearchParams({ from, to })}`);
};

export const invoiceByServiceReport = async (
  from: string,
  to: string
): Promise<ApiResponse<InvoiceByServiceReport[]>> => {
  return await Api.get(`/reports/invoice?${new URLSearchParams({ from, to })}`);
};

export const downloadEodReport = async (
  from: string,
  to: string
): Promise<any> => {
  return await Api.get(
    `/reports/download/eod?${new URLSearchParams({ from, to })}`,
    {
      responseType: "blob",
      headers: {
        Accept: "text/csv",
      },
    }
  );
};

export const getComprehensiveReport = async (
  from: string,
  to: string,
  filter: ComprehensiveReportFilters,
  storeId?: string
): Promise<ApiResponse<ComprehensiveReportResponse>> => {
  const queryString = new URLSearchParams({
    from,
    to,
  }).toString();

  return await Api.post(`/reports/comprehensive?${queryString}`, filter, {
    headers: {
      "x-store-id": storeId, // assuming StoreId() decorator uses this header
    },
  });
};

export const getComprehensiveReportFilters = async (
  from: string,
  to: string,
  storeId?: string
): Promise<ApiResponse<FiltersData>> => {
  const queryString = new URLSearchParams({
    from,
    to,
  }).toString();

  return await Api.get(`/reports/comprehensive/filters?${queryString}`, {
    headers: {
      "x-store-id": storeId, // assuming StoreId() decorator uses this header
    },
  });
};

export const downloadComprehensiveReport = async (
  from: string,
  to: string,
  filter: ComprehensiveReportFilters,
  storeId?: string
): Promise<ApiResponse<ComprehensiveReportResponse>> => {
  const queryString = new URLSearchParams({
    from,
    to,
  }).toString();

  return await Api.post(
    `/reports/comprehensive/export?${queryString}`,
    filter,
    {
      headers: {
        "x-store-id": storeId, // assuming StoreId() decorator uses this header
      },
    }
  );
};

const ReportService = {
  eodReport,
  downloadEodReport,
  invoiceByServiceReport,
  getComprehensiveReport,
  getComprehensiveReportFilters,
  downloadComprehensiveReport,
};
export default ReportService;
